module.exports = __webpack_public_path__ + "img/13129ce630d7f722c4e56ac258f0065d.png";